import { BaseTooltip } from "./BaseTooltip";

import { BubbleTooltipElement } from "./logic/BubbleTooltipElement";

export class BubbleTooltip extends BaseTooltip {
    createTooltipElementInternal() {
        return new BubbleTooltipElement;
    }
}
//# sourceMappingURL=Tooltip.js.map
